import store from '@/store/index';

const getViewReportRequiredPrivileges = (index) => {
    var reportTypeIds = store.state.common.listGroupReportTypes[index].reportTypeIds;
    var reportTypes = store.state.common.listReportSyncTypes.filter(x => reportTypeIds.indexOf(x.id) != -1);

    return reportTypes.map(x => 'ViewReport_' + x.table.substr(4));
};

export default [
    {
        _name: 'CSidebarNav',
        _children: [
            //{
            //    _name: 'CSidebarNavItem',
            //    code: 'home',
            //    name: 'Trang chủ',
            //    to: '/home',
            //    icon: 'cil-home'
            //},
            {
                _name: 'CSidebarNavDropdown2',
                code: 'system',
                name: 'Quản trị hệ thống',
                route: '/system',
                icon: 'cil-settings',
                items: [
                    {
                        code: 'manage_users',
                        name: 'Quản lý người dùng',
                        to: '/system/users',
                        icon: 'cil-user',
                        requiresPrivileges: ['ViewUser', 'ManageUser']
                    },
                    {
                        code: 'manage_roles',
                        name: 'Quản lý nhóm người dùng',
                        to: '/system/roles',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewRole', 'ManageRole']
                    },
                    {
                        code: 'manage_exploitation_users',
                        name: 'Quản lý tài khoản khai thác',
                        to: '/system/exploitation-users',
                        icon: 'cil-user',
                        requiresPrivileges: ['ViewExploitationUser', 'ManageExploitationUser']
                    },
                    {
                        code: 'manage_exploiting_roles',
                        name: 'QL nhóm tài khoản khai thác',
                        to: '/system/exploitation-roles',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewExploitationRole', 'ManageExploitationRole']
                    },
                    {
                        code: 'manage_sync_users',
                        name: 'QL tài khoản đơn vị đồng bộ',
                        to: '/system/sync-users',
                        icon: 'cil-user',
                        requiresPrivileges: ['ViewSyncUser', 'ManageSyncUser']
                    },
                    {
                        code: 'manage_sync_roles',
                        name: 'QL nhóm tài khoản đồng bộ',
                        to: '/system/sync-roles',
                        icon: 'cil-people',
                        requiresPrivileges: ['ViewSyncRole', 'ManageSyncRole']
                    },
                    {
                        code: 'approved_users',
                        name: 'Duyệt người dùng',
                        to: '/system/approved-users',
                        icon: 'cilLog',
                        requiresPrivileges: ['ViewApprovedUser', 'ManageApprovedUser']
                    },
                    {
                        code: 'manage_system_parameters',
                        name: 'Tham số hệ thống',
                        to: '/system/system-parameters',
                        icon: 'cilParameter',
                        requiresPrivileges: ['ManageSystemParameter']
                    },
                    {
                        code: 'manage_report_parameters',
                        name: 'Tham số báo cáo',
                        to: '/system/report-parameters',
                        icon: 'cilListRich',
                        requiresPrivileges: ['ManageReportParameter']
                    },
                    {
                        code: 'manage_sync_parameters',
                        name: 'Tham số đồng bộ dữ liệu',
                        to: '/system/sync-parameters',
                        icon: 'cilLineStyle',
                        requiresPrivileges: ['ManageSyncParameter']
                    },
                    {
                        code: 'backup_restore_data',
                        name: 'Sao lưu/phục hồi dữ liệu',
                        to: '/system/backups',
                        icon: 'cilDatabaseBackup',
                        requiresPrivileges: ['ManageBackup']
                    },
                    {
                        code: 'backup_data',
                        name: 'Sao lưu dữ liệu tài sản, báo cáo',
                        to: '/system/backup_data',
                        icon: 'cilDatabaseBackup',
                        adminOnly: true
                    },
                    {
                        code: 'restore_data',
                        name: 'Phục hồi dữ liệu tài sản, báo cáo',
                        to: '/system/restore_data',
                        icon: 'cilDatabaseBackup',
                        adminOnly: true
                    },
                    {
                        code: 'backup_config',
                        name: 'Sao lưu dữ liệu toàn hệ thống',
                        to: '/system/backup_config',
                        icon: 'cilDatabaseBackup',
                        adminOnly: true
                    },
                    //{
                    //    code: 'manage_field_mapping',
                    //    name: 'Mapping dữ liệu tài sản',
                    //    to: '/system/field-mapping/index',
                    //    icon: 'cilArrowThickRight',
                    //    adminOnly: true
                    //},
                    {
                        code: 'field_mapping_display',
                        name: 'Cấu hình form hiển thị',
                        to: '/system/field-mapping/display',
                        icon: 'cilList',
                        adminOnly: true
                    },
                    //{
                    //    code: 'asset_type_mapping',
                    //    name: 'Cấu hình nhóm tài sản lớn',
                    //    to: '/system/asset-type-mappings',
                    //    icon: 'cilGrid',
                    //    adminOnly: true
                    //}
                    {
                        code: 'mapping_report_type_sync_data_source',
                        name: 'Mapping báo cáo định kỳ/ đột xuất',
                        to: '/system/report-type-sync-data-source/list',
                        icon: 'cilList',
                        adminOnly: true
                    },
                    {
                        code: 'report_request_parameter',
                        name: 'Cấu hình yêu cầu báo cáo định kỳ',
                        to: '/system/report-request-parameter/list',
                        icon: 'cilList',
                        adminOnly: true
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'manage_master_data',
                name: 'Quản lý danh mục',
                route: '/master-data',
                icon: 'cilBook',
                items: [
                    {
                        code: 'manage_unit_types',
                        name: 'Phân loại đơn vị',
                        to: '/master-data/unit-types',
                        icon: 'cilSitemap',
                        requiresPrivileges: ['ViewUnitType', 'ManageUnitType'],
                    },
                    {
                        code: 'manage_units',
                        name: 'Đơn vị',
                        to: '/master-data/units',
                        icon: 'cilBuilding',
                        requiresPrivileges: ['ViewUnit', 'ManageUnit']
                    },
                    {
                        code: 'manage_departments',
                        name: 'Bộ phận sử dụng',
                        to: '/master-data/departments',
                        icon: 'cilDepartment',
                        requiresPrivileges: ['ViewDepartment', 'ManageDepartment']
                    },
                    {
                        code: 'manage_projects',
                        name: 'Dự án',
                        to: '/master-data/projects',
                        icon: 'cilProject',
                        requiresPrivileges: ['ViewProject', 'ManageProject']
                    },
                    {
                        code: 'manage_asset_type_trees',
                        name: 'Cây phân loại tài sản',
                        to: '/master-data/asset-type-trees',
                        icon: 'cilSitemap',
                        requiresPrivileges: ['ViewAssetTypeTree', 'ManageAssetTypeTree'],
                    },
                    {
                        code: 'manage_asset_types',
                        name: 'Nhóm tài sản',
                        to: '/master-data/asset-types',
                        icon: 'cilGrid',
                        requiresPrivileges: ['ViewAssetType', 'ManageAssetType']
                    },
                    {
                        code: 'manage_asset_mutation_cause_types',
                        name: 'Loại lý do biến động',
                        to: '/master-data/asset-mutation-cause-types',
                        icon: 'cilDistributedData',
                        requiresPrivileges: ['ViewAssetMutationCauseType', 'ManageAssetMutationCauseType'],
                    },
                    {
                        code: 'manage_asset_mutation_causes',
                        name: 'Lý do biến động',
                        to: '/master-data/asset-mutation-causes',
                        icon: 'cilQuestionMark',
                        requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'],
                    },
                    {
                        code: 'manage_increasement_causes',
                        name: 'Lý do tăng',
                        to: '/master-data/increasement-causes',
                        icon: 'cilArrowCircleTop',
                        requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'],
                    },
                    {
                        code: 'manage_decreasement_causes',
                        name: 'Lý do giảm',
                        to: '/master-data/decreasement-causes',
                        icon: 'cilArrowCircleBottom',
                        requiresPrivileges: ['ViewAssetMutationCause', 'ManageAssetMutationCause'],
                    },
                    {
                        code: 'manage_asset_sources',
                        name: 'Nguồn hình thành tài sản',
                        to: '/master-data/asset-sources',
                        icon: 'cilHistory',
                        requiresPrivileges: ['ViewAssetSource', 'ManageAssetSource'],
                    },
                    {
                        code: 'manage_handling_forms',
                        name: 'Hình thức xử lý tài sản xác lập',
                        to: '/master-data/asset-handling-forms',
                        icon: 'cilLightbulb',
                        requiresPrivileges: ['ViewHandlingForm', 'ManageHandlingForm'],
                    },
                    {
                        code: 'manage_handling_methods',
                        name: 'Phương thức xử lý tài sản xác lập',
                        to: '/master-data/asset-handling-methods',
                        icon: 'cilHandTruckMoving',
                        requiresPrivileges: ['ViewHandlingMethod', 'ManageHandlingMethod'],
                    },
                    {
                        code: 'manage_usage_states',
                        name: 'Hiện trạng sử dụng',
                        to: '/master-data/asset-usage-states',
                        icon: 'cilMonitor',
                        requiresPrivileges: ['ViewUsageState', 'ManageUsageState'],
                    },
                    {
                        code: 'manage_usage_purposes',
                        name: 'Mục đích sử dụng',
                        to: '/master-data/asset-usage-purposes',
                        icon: 'cilAim',
                        requiresPrivileges: ['ViewUsagePurpose', 'ManageUsagePurpose'],
                    },
                    {
                        code: 'manage_countries',
                        name: 'Danh mục quốc gia',
                        to: '/master-data/countries',
                        icon: 'cilGlobeAlt',
                        requiresPrivileges: ['ViewCountry', 'ManageCountry'],
                    },
                    {
                        code: 'manage_regions',
                        name: 'Danh mục địa bàn',
                        to: '/master-data/regions',
                        icon: 'cilLocationPin',
                        requiresPrivileges: ['ViewRegion', 'ManageRegion'],
                    }
                ]
            },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'manage_data',
                name: 'Quản lý dữ liệu đồng bộ',
                route: '/data',
                icon: 'cilMonitorData',
                _children: [
                    {
                        _name: 'CSidebarNavItem',
                        code: 'list_assets',
                        name: 'Danh sách tài sản',
                        to: '/data/assets/list',
                        adminOnly: true,
                        icon: 'cilAsset'
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'list_asset_mutations',
                        name: 'Danh sách biến động',
                        to: '/data/assets/asset-mutations/list',
                        adminOnly: true,
                        icon: 'cilDataChange'
                    },
                    {
                        _name: 'CSidebarNavDropdown',
                        code: 'manage_organization_assets',
                        name: 'Tài sản tại cơ quan, tổ chức, đơn vị',
                        route: '/data/organization-assets',
                        requiresPrivileges: ['QLTSC_ViewAsset', 'QLTSC_ManageAsset', 'QLTSC_ViewAssetMutation', 'QLTSC_ManageAssetMutation', 'ViewAssetInventory', 'ManageAssetInventory', 'ViewAssetExploitationDecision', 'ManageAssetExploitationDecision', 'ViewAssetExploitationDocument', 'ManageAssetExploitationDocument'],
                        icon: 'cilAsset',
                        items: [
                            {
                                code: 'list_organization_assets',
                                name: 'Danh sách tài sản',
                                to: '/data/organization-assets/list',
                                requiresPrivileges: ['QLTSC_ViewAsset', 'QLTSC_ManageAsset'],
                                icon: 'cilAsset'
                            },
                            {
                                code: 'list_organization_asset_mutations',
                                name: 'Danh sách biến động',
                                to: '/data/organization-assets/asset-mutations/list',
                                icon: 'cilDataChange',
                                requiresPrivileges: ['QLTSC_ViewAssetMutation', 'QLTSC_ManageAssetMutation']
                            },
                            {
                                code: 'list_organization_asset_inventories',
                                name: 'Kiểm kê tài sản',
                                to: '/data/organization-assets/asset-inventories/list',
                                icon: 'cilCheckList',
                                requiresPrivileges: ['ViewAssetInventory', 'ManageAssetInventory']
                            },
                            {
                                _name: 'CSidebarNavItem',
                                code: 'list_organization_asset_exploitations',
                                name: 'Khai thác tài sản',
                                to: '/data/organization-assets/asset-exploitation-decisions/list',
                                icon: 'cilHandling',
                                requiresPrivileges: ['ViewAssetExploitationDecision', 'ManageAssetExploitationDecision', 'ViewAssetExploitationDocument', 'ManageAssetExploitationDocument']
                            }
                        ]
                    },
                    {
                        _name: 'CSidebarNavDropdown',
                        code: 'manage_infrastructure_assets',
                        name: 'Tài sản kết cấu hạ tầng',
                        route: '/data/infrastructure-assets',
                        requiresPrivileges: ['CTNS_ViewAsset', 'CTNS_ManageAsset', 'CTNS_ViewAssetMutation', 'CTNS_ManageAssetMutation'
                            , 'HTGTDB_ViewAsset', 'HTGTDB_ManageAsset', 'HTGTDB_ViewAssetMutation', 'HTGTDB_ManageAssetMutation'
                            , 'KCHTDS_ViewAsset', 'KCHTDS_ManageAsset', 'KCHTDS_ViewAssetMutation', 'KCHTDS_ManageAssetMutation'
                            , 'KCHTTL_ViewAsset', 'KCHTTL_ManageAsset', 'KCHTTL_ViewAssetMutation', 'KCHTTL_ManageAssetMutation'
                            , 'KCHTHK_ViewAsset', 'KCHTHK_ManageAsset', 'KCHTHK_ViewAssetMutation', 'KCHTHK_ManageAssetMutation'
                            , 'KCHTHH_ViewAsset', 'KCHTHH_ManageAsset', 'KCHTHH_ViewAssetMutation', 'KCHTHH_ManageAssetMutation'
                            , 'KCHTGTDTND_ViewAsset', 'KCHTGTDTND_ManageAsset', 'KCHTGTDTND_ViewAssetMutation', 'KCHTGTDTND_ManageAssetMutation'
                            , 'KCHTK_ViewAsset', 'KCHTK_ManageAsset', 'KCHTK_ViewAssetMutation', 'KCHTK_ManageAssetMutation'],
                        icon: 'cilAsset',
                        _children: [
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_ctns',
                                name: 'Công trình nước sạch',
                                route: '/data/infrastructure-assets/ctns',
                                requiresPrivileges: ['CTNS_ViewAsset', 'CTNS_ManageAsset', 'CTNS_ViewAssetMutation', 'CTNS_ManageAssetMutation'],
                                icon: 'cilWaterTap',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_ctns',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/ctns/list',
                                        requiresPrivileges: ['CTNS_ViewAsset', 'CTNS_ManageAsset',],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_ctns',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/ctns/asset-mutations/list',
                                        requiresPrivileges: ['CTNS_ViewAssetMutation', 'CTNS_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_htgtdb',
                                name: 'Hạ tầng giao thông đường bộ',
                                route: '/data/infrastructure-assets/htgtdb',
                                requiresPrivileges: ['HTGTDB_ViewAsset', 'HTGTDB_ManageAsset', 'HTGTDB_ViewAssetMutation', 'HTGTDB_ManageAssetMutation'],
                                icon: 'cilRoad',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_htgtdb',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/htgtdb/list',
                                        requiresPrivileges: ['HTGTDB_ViewAsset', 'HTGTDB_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_htgtdb',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/htgtdb/asset-mutations/list',
                                        requiresPrivileges: ['HTGTDB_ViewAssetMutation', 'HTGTDB_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_kchtds',
                                name: 'KCHT đường sắt',
                                route: '/data/infrastructure-assets/kchtds',
                                requiresPrivileges: ['KCHTDS_ViewAsset', 'KCHTDS_ManageAsset', 'KCHTDS_ViewAssetMutation', 'KCHTDS_ManageAssetMutation'],
                                icon: 'cilLocomotive',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_kchtds',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/kchtds/list',
                                        requiresPrivileges: ['KCHTDS_ViewAsset', 'KCHTDS_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_kchtds',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/kchtds/asset-mutations/list',
                                        requiresPrivileges: ['KCHTDS_ViewAssetMutation', 'KCHTDS_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_kchttl',
                                name: 'KCHT thủy lợi',
                                route: '/data/infrastructure-assets/kchttl',
                                requiresPrivileges: ['KCHTTL_ViewAsset', 'KCHTTL_ManageAsset', 'KCHTTL_ViewAssetMutation', 'KCHTTL_ManageAssetMutation'],
                                icon: 'cilSprinkler',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_kchttl',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/kchttl/list',
                                        requiresPrivileges: ['KCHTTL_ViewAsset', 'KCHTTL_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_kchttl',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/kchttl/asset-mutations/list',
                                        requiresPrivileges: ['KCHTTL_ViewAssetMutation', 'KCHTTL_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_kchthk',
                                name: 'KCHT hàng không',
                                route: '/data/infrastructure-assets/kchthk',
                                requiresPrivileges: ['KCHTHK_ViewAsset', 'KCHTHK_ManageAsset', 'KCHTHK_ViewAssetMutation', 'KCHTHK_ManageAssetMutation'],
                                icon: 'cilAirplaneMode',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_kchthk',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/kchthk/list',
                                        requiresPrivileges: ['KCHTHK_ViewAsset', 'KCHTHK_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_kchthk',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/kchthk/asset-mutations/list',
                                        requiresPrivileges: ['KCHTHK_ViewAssetMutation', 'KCHTHK_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_kchthh',
                                name: 'KCHT hàng hải',
                                route: '/data/infrastructure-assets/kchthh',
                                requiresPrivileges: ['KCHTHH_ViewAsset', 'KCHTHH_ManageAsset', 'KCHTHH_ViewAssetMutation', 'KCHTHH_ManageAssetMutation'],
                                icon: 'cilBoatAlt',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_kchthh',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/kchthh/list',
                                        requiresPrivileges: ['KCHTHH_ViewAsset', 'KCHTHH_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_kchthh',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/kchthh/asset-mutations/list',
                                        requiresPrivileges: ['KCHTHH_ViewAssetMutation', 'KCHTHH_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_kchtgtdtnd',
                                name: 'KCHT giao thông đường thủy nội địa',
                                route: '/data/infrastructure-assets/kchtgtdtnd',
                                requiresPrivileges: ['KCHTGTDTND_ViewAsset', 'KCHTGTDTND_ManageAsset', 'KCHTGTDTND_ViewAssetMutation', 'KCHTGTDTND_ManageAssetMutation'],
                                icon: 'cilBoatToy',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_kchtgtdtnd',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/kchtgtdtnd/list',
                                        requiresPrivileges: ['KCHTGTDTND_ViewAsset', 'KCHTGTDTND_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_kchtgtdtnd',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/kchtgtdtnd/asset-mutations/list',
                                        requiresPrivileges: ['KCHTGTDTND_ViewAssetMutation', 'KCHTGTDTND_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            },
                            {
                                _name: 'CSidebarNavDropdown',
                                code: 'manage_infrastructure_assets_kchtk',
                                name: 'KCHT khác',
                                route: '/data/infrastructure-assets/kchtk',
                                requiresPrivileges: ['KCHTK_ViewAsset', 'KCHTK_ManageAsset', 'KCHTK_ViewAssetMutation', 'KCHTK_ManageAssetMutation'],
                                icon: 'cilEllipsis',
                                items: [
                                    {
                                        code: 'list_infrastructure_assets_kchtk',
                                        name: 'Danh sách tài sản',
                                        to: '/data/infrastructure-assets/kchtk/list',
                                        requiresPrivileges: ['KCHTK_ViewAsset', 'KCHTK_ManageAsset'],
                                        icon: 'cilAsset'
                                    },
                                    {
                                        code: 'list_infrastructure_asset_mutations_kchtk',
                                        name: 'Danh sách biến động',
                                        to: '/data/infrastructure-assets/kchtk/asset-mutations/list',
                                        requiresPrivileges: ['KCHTK_ViewAssetMutation', 'KCHTK_ManageAssetMutation'],
                                        icon: 'cilDataChange'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        _name: 'CSidebarNavDropdown',
                        code: 'manage_national_public_assets',
                        name: 'Tài sản xác lập sở hữu toàn dân',
                        route: '/data/national-public-assets',
                        requiresPrivileges: ['ViewNationalPublicAsset', 'ManageNationalPublicAsset'
                            , 'ViewNationalPublicAssetHandling', 'ManageNationalPublicAssetHandling'
                            , 'ViewNationalPublicAssetConfiscateDecision', 'ManageNationalPublicAssetConfiscateDecision'
                            , 'ViewNationalPublicAssetHandlingDecisionResult', 'ManageNationalPublicAssetHandlingDecisionResult'
                            , 'ViewNationalPublicAssetHandlingAccounting', 'ManageNationalPublicAssetHandlingAccounting'],
                        icon: 'cilAsset',
                        items: [
                            {
                                code: 'list_national_public_assets',
                                name: 'Danh sách tài sản',
                                to: '/data/national-public-assets/list',
                                icon: 'cilBank',
                                requiresPrivileges: ['ViewNationalPublicAsset', 'ManageNationalPublicAsset']
                            },
                            {
                                code: 'list_national_public_asset_confiscate_decisions',
                                name: 'Quyết định tịch thu/ xác lập',
                                to: '/data/national-public-assets/confiscate-decisions/list',
                                icon: 'cilLibrary',
                                requiresPrivileges: ['ViewNationalPublicAssetConfiscateDecision', 'ManageNationalPublicAssetConfiscateDecision']
                            },
                            {
                                code: 'list_national_public_asset_handlings',
                                name: 'Phương án xử lý',
                                to: '/data/national-public-assets/asset-handlings/list',
                                icon: 'cilHandling',
                                requiresPrivileges: ['ViewNationalPublicAssetHandling', 'ManageNationalPublicAssetHandling']
                            },
                            {
                                code: 'list_national_public_asset_handling_decision_results',
                                name: 'Kết quả xử lý',
                                to: '/data/national-public-assets/handling-decision-results/list',
                                icon: 'cilAddressBook',
                                requiresPrivileges: ['ViewNationalPublicAssetHandlingDecisionResult', 'ManageNationalPublicAssetHandlingDecisionResult']
                            },
                            {
                                code: 'list_national_public_asset_handling_decision_accountings',
                                name: 'Quản lý thu chi',
                                to: '/data/national-public-assets/handling-decision-accountings/list',
                                icon: 'cilMoney',
                                requiresPrivileges: ['ViewNationalPublicAssetHandlingAccounting', 'ManageNationalPublicAssetHandlingAccounting']
                            },
                        ]
                    },
                    {
                        _name: 'CSidebarNavDropdown',
                        code: 'manage_land_assets',
                        name: 'Đất đai',
                        route: '/data/land-assets',
                        requiresPrivileges: ['DATDAI_ViewAsset', 'DATDAI_ManageAsset', 'DATDAI_ViewAssetMutation', 'DATDAI_ManageAssetMutation'],
                        icon: 'cilAsset',
                        items: [
                            {
                                code: 'list_land_assets',
                                name: 'Danh sách tài sản',
                                to: '/data/land-assets/list',
                                requiresPrivileges: ['DATDAI_ViewAsset', 'DATDAI_ManageAsset'],
                                icon: 'cilAsset'
                            },
                            {
                                code: 'list_land_asset_mutations',
                                name: 'Danh sách biến động',
                                to: '/data/land-assets/asset-mutations/list',
                                icon: 'cilDataChange',
                                requiresPrivileges: ['DATDAI_ViewAssetMutation', 'DATDAI_ManageAssetMutation']
                            },
                        ]
                    },
                    {
                        _name: 'CSidebarNavDropdown',
                        code: 'manage_resource_assets',
                        name: 'Tài nguyên',
                        route: '/data/resource-assets',
                        requiresPrivileges: ['TAINGUYEN_ViewAsset', 'TAINGUYEN_ManageAsset', 'TAINGUYEN_ViewAssetMutation', 'TAINGUYEN_ManageAssetMutation'],
                        icon: 'cilAsset',
                        items: [
                            {
                                code: 'list_resource_assets',
                                name: 'Danh sách tài sản',
                                to: '/data/resource-assets/list',
                                requiresPrivileges: ['TAINGUYEN_ViewAsset', 'TAINGUYEN_ManageAsset'],
                                icon: 'cilAsset'
                            },
                            {
                                code: 'list_resource_asset_mutations',
                                name: 'Danh sách biến động',
                                to: '/data/resource-assets/asset-mutations/list',
                                icon: 'cilDataChange',
                                requiresPrivileges: ['TAINGUYEN_ViewAssetMutation', 'TAINGUYEN_ManageAssetMutation']
                            },
                        ]
                    },
                    {
                        _name: 'CSidebarNavDropdown',
                        code: 'manage_public_enterprise_assets',
                        name: 'Tài sản công tại doanh nghiệp',
                        route: '/data/public-enterprise-assets',
                        requiresPrivileges: ['TSCTDN_ViewAsset', 'TSCTDN_ManageAsset', 'TSCTDN_ViewAssetMutation', 'TSCTDN_ManageAssetMutation'],
                        icon: 'cilAsset',
                        items: [
                            {
                                code: 'list_public_enterprise_assets',
                                name: 'Danh sách tài sản',
                                to: '/data/public-enterprise-assets/list',
                                requiresPrivileges: ['TSCTDN_ViewAsset', 'TSCTDN_ManageAsset'],
                                icon: 'cilAsset'
                            },
                            {
                                code: 'list_public_enterprise_asset_mutations',
                                name: 'Danh sách biến động',
                                to: '/data/public-enterprise-assets/asset-mutations/list',
                                icon: 'cilDataChange',
                                requiresPrivileges: ['TSCTDN_ViewAssetMutation', 'TSCTDN_ManageAssetMutation']
                            },
                        ]
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'manage_reports',
                        name: 'Báo cáo',
                        to: '/data/reports',
                        icon: 'cilChart',
                        requiresPrivileges: ['ViewReport', 'ManageReport']
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'reports_stats',
                        name: 'Thống kê báo cáo đồng bộ',
                        to: '/data/reports/stats',
                        icon: 'cilApplications',
                        adminOnly: true
                    }
                ]

            },
            {
                _name: 'CSidebarNavDropdown2',
                code: 'reporting',
                name: 'Tổng hợp báo cáo',
                route: '/view-reports',
                icon: 'cilChart',
                items: [
                    {
                        code: 'view_summary_reports',
                        name: 'Báo cáo tổng hợp',
                        to: '/view-reports/summary',
                        icon: 'cilChart',
                        requiresPrivileges: getViewReportRequiredPrivileges(0)
                    },
                    {
                        code: 'view_public_reports',
                        name: 'Báo cáo công khai',
                        to: '/view-reports/public',
                        icon: 'cilChart',
                        requiresPrivileges: getViewReportRequiredPrivileges(1)
                    },
                    {
                        code: 'view_government_reports',
                        name: 'Báo cáo chính phủ',
                        to: '/view-reports/goverment',
                        icon: 'cilChart',
                        requiresPrivileges: getViewReportRequiredPrivileges(2)
                    },
                    {
                        code: 'view_national_asset_type_reports',
                        name: 'Báo cáo tài sản tịch thu/ xác lập',
                        to: '/view-reports/national-asset-type',
                        icon: 'cilChart',
                        requiresPrivileges: getViewReportRequiredPrivileges(4)
                    },
                    {
                        code: 'view_other_reports',
                        name: 'Báo cáo khác',
                        to: '/view-reports/other',
                        icon: 'cilChart',
                        requiresPrivileges: getViewReportRequiredPrivileges(3)
                    },
                    {
                        code: 'view_lookup_reports',
                        name: 'Báo cáo tra cứu',
                        to: '/view-reports/lookup',
                        icon: 'cilChart',
                        requiresPrivileges: ['ViewLookupReport']
                    },
                    //{
                    //    code: 'view_lookup_reports_auto',
                    //    name: 'Báo cáo đối chiếu dữ liệu',
                    //    to: '/view-reports/BCDC',
                    //    icon: 'cilChart',
                    //    requiresPrivileges: ['ViewCompareReport']
                    //}
                ]
            },

            {
                _name: 'CSidebarNavDropdown2',
                code: 'system_logs',
                name: 'Nhật ký hệ thống',
                route: '/logs',
                icon: 'cilLog',
                _children: [
                    {
                        _name: 'CSidebarNavItem',
                        code: 'action_logs',
                        name: 'Nhật ký thao tác dữ liệu',
                        to: '/logs/action',
                        icon: 'cilTouchApp',
                        requiresPrivileges: ['ViewActionLog']
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'master_data_sync_logs',
                        name: 'Nhật ký đồng bộ danh mục',
                        to: '/logs/sync/masterdata',
                        icon: 'cilBook',
                        adminOnly: true
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'asset_sync_logs',
                        name: 'Nhật ký đồng bộ tài sản',
                        to: '/logs/sync/assets',
                        icon: 'cilAsset',
                        requiresPrivileges: ['ViewAssetSyncLog']
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'asset_info_sync_logs',
                        name: 'Nhật ký đồng bộ biến động tài sản',
                        to: '/logs/sync/assets-info',
                        icon: 'cilDataChange',
                        requiresPrivileges: ['ViewAssetSyncLog']
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'report_sync_logs',
                        name: 'Nhật ký đồng bộ báo cáo',
                        to: '/logs/sync/reports',
                        icon: 'cilChart',
                        requiresPrivileges: ['ViewReportSyncLog']
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'backup_logs',
                        name: 'Nhật ký sao lưu dữ liệu',
                        to: '/logs/backup',
                        icon: 'cilDatabaseBackup',
                        requiresPrivileges: ['ViewBackupLog']
                    },
                    //{
                    //    _name: 'CSidebarNavItem',
                    //    code: 'analysis_logs',
                    //    name: 'Nhật ký đồng bộ dữ liệu',
                    //    to: '/logs/analysis',
                    //    icon: 'cilLayers',
                    //    adminOnly: true
                    //},
                    {
                        _name: 'CSidebarNavItem',
                        code: 'services_logs',
                        name: 'Nhật ký đồng bộ dữ liệu sang QLTSC',
                        to: '/logs/services',
                        icon: 'cilSignLanguage',
                        requiresPrivileges: ['ViewActionLog']
                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'request_logs',
                        name: 'Nhật ký yêu cầu báo cáo',
                        to: '/logs/report-requests',
                        icon: 'cilChart',
                        adminOnly: true,

                    },
                    {
                        _name: 'CSidebarNavItem',
                        code: 'search_sync_logs',
                        name: 'Theo dõi lịch sử đồng bộ dữ liệu',
                        to: '/logs/search',
                        adminOnly: true,
                        icon: 'cilLog'
                    }
                ]
            },

            {
                _name: 'CSidebarNavDropdown2',
                code: 'help',
                name: 'Tiện ích',
                route: '/help',
                icon: 'cilTool',
                items: [
                    {
                        code: 'help_notifications_asset_info_error',
                        name: 'Tài sản đồng bộ lỗi',
                        to: '/help/notifications/asset-info-error',
                        icon: 'cilWarning',
                        requiresPrivileges: ['ViewAssetSyncError']
                    },
                    {
                        code: 'help_notifications_asset_info_subs',
                        name: 'Tài sản cấp dưới đồng bộ',
                        to: '/help/notifications/asset-info-subs',
                        icon: 'cilMagnifyingGlass',
                        requiresPrivileges: ['ViewAssetSyncSub']
                    },
                    {
                        code: 'help_notifications_asset_exploitation_error',
                        name: 'Hoạt động KTTS đồng bộ lỗi',
                        to: '/help/notifications/asset-exploitation-error',
                        icon: 'cilWarning',
                        requiresPrivileges: ['ViewAssetExploitationSyncError']
                    },
                    {
                        code: 'help_notifications_asset_exploitation_subs',
                        name: 'Hoạt động KTTS cấp dưới đồng bộ',
                        to: '/help/notifications/asset-exploitation-subs',
                        icon: 'cilMagnifyingGlass',
                        requiresPrivileges: ['ViewAssetExploitationSyncSub']
                    },
                    {
                        code: 'help_notifications_report_error',
                        name: 'Báo cáo đồng bộ lỗi',
                        to: '/help/notifications/report-error',
                        icon: 'cilWarning',
                        requiresPrivileges: ['ViewReportSyncError']
                    },
                    {
                        code: 'help_notifications_report_subs',
                        name: 'Báo cáo cấp dưới đồng bộ',
                        to: '/help/notifications/report-subs',
                        icon: 'cilMagnifyingGlass',
                        requiresPrivileges: ['ViewReportSyncSub']
                    },
                    {
                        code: 'search_user_manuals',
                        name: 'Tài liệu hướng dẫn sử dụng',
                        to: '/help/user-manuals',
                        icon: 'cilGuide',
                        requiresPrivileges: ['ViewUserManual', 'ManageUserManual']
                    },
                    {
                        code: 'import-users',
                        name: 'Import users',
                        to: '/help/import-users/import',
                        icon: 'cilKeyboard',
                        requiresPrivileges: ['ViewUserManual', 'ManageUserManual']
                    },
                    //{
                    //    code: 'verify_data',
                    //    name: 'Xác nhận dữ liệu',
                    //    to: '/help/verify-data/verify',
                    //    icon: 'cilThumbUp',
                    //    topLevelOnly: true
                    //},
                    //{
                    //    code: 'list_verify_data',
                    //    name: 'Tổng hợp xác nhận dữ liệu',
                    //    to: '/help/verify-data/list',
                    //    icon: 'cilKeyboard',
                    //    adminOnly: true
                    //}
                ]
            }
        ]
    }
]